import DeterminedAndArrangedInstallation from './DeterminedAndArrangedInstallation';

export default DeterminedAndArrangedInstallation;